import axiosCore from 'axios';
import { fauth } from '../plugins/firebase';

export default class MagentoAxios {
  get instance() {
    return this.axiosInstance;
  }

  set instance(instance) {
    this.axiosInstance = instance;
  }

  constructor(url) {
    this.url = url;
    this.axiosInstance = axiosCore.create({
      headers: {
        'Content-Type': 'text/plain'
      },
      transformRequest: (data) => JSON.stringify(data)
    });

    this.axiosInstance.interceptors.request.use(async (config) => {
      let url = config.url;
      const user = fauth.currentUser;

      if (user) {
        const token = await user.getIdToken();
        const auth = encodeURIComponent(`Bearer ${token}`);

        if (url.includes("?")) {
          url += `&authorization=${auth}`;
        } else {
          url += `?authorization=${auth}`;
        }

        config.url = url;
      }
  
      return config;
    });
  }

  async post(fn, data, headers) {
    const sendData = {
      headers: headers || {},
      data: data || {}
    };

    const response = await this.axiosInstance.post(this.url + fn, sendData);
    return response.data;
  }

  async get(fn, params) {
    const endURl = (params != null && Object.keys(params).length > 0) ? this.url + fn + '?' + new URLSearchParams(params) : this.url + fn;
    const response = await this.axiosInstance.get(endURl);

    return response.data;
  }
}
